var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isThirdSystem())?_c('div',{staticClass:"bottom-cube"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }